var _style, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 17.5 17.5",
    style: {
      enableBackground: "new 0 0 17.5 17.5"
    },
    xmlSpace: "preserve",
    color: "#262A3E",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.integrations-svg{fill:none;stroke:currentColor;stroke-width:1.5;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M0.8,16.8l2-2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M3.9,7.9L2.7,9.1C2,9.9,1.5,10.9,1.5,12S2,14,2.7,14.8C3.5,15.5,4.5,16,5.5,16s2.1-0.4,2.8-1.2l1.2-1.2L3.9,7.9 z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M16.7,0.8l-2,2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M13.6,9.6l1.2-1.2C15.5,7.6,16,6.6,16,5.6s-0.4-2.1-1.2-2.8C14,2,13,1.5,11.9,1.5c-1.1,0-2.1,0.4-2.8,1.2 L7.9,3.9L13.6,9.6z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M7.2,8L5.6,9.6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "integrations-svg",
    d: "M9.6,10.4L8,12"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrations);
export default __webpack_public_path__ + "static/media/integrations.6cd8998f56acba516ca816bd09765880.svg";
export { ForwardRef as ReactComponent };